import { ensureHeaderMicrofrontend } from '../../microfrontend';
import { IOpenAuthModalParameters } from '../../../../../shared/types/microfrontends';

export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  const microfrontend = await ensureHeaderMicrofrontend();

  return microfrontend?.call('/v3/open-auth-modal/', parameters);
}
